export const SERVIZI_SLUG = 'servizi';
export const SERVIZI_ROUTE = `/${SERVIZI_SLUG}`;
export const getServiziRoute = () => SERVIZI_ROUTE;
export const getServiziBreadcrumb = () => ({
  title: 'HOME',
  url: SERVIZI_ROUTE,
});

export const NOT_FOUND_SLUG = '404';
export const NOT_FOUND_ROUTE = `/${NOT_FOUND_SLUG}`;
export const getNotFoundRoute = () => NOT_FOUND_ROUTE;
